export default function uaeManualPayments(fetch, baseUrl) {
  return {
    getAllPaymentsInLast10Minutes() {
      return fetch.get(baseUrl);
    }
  };
}
